import { combineReducers } from 'redux';
import warehouse, { initialState as warehouseInitialState } from './warehouse';
import cart, { initialState as cartInitialState } from './cart';
import auth, { initialState as authInitialState } from './auth';
import client, { initialState as clientInitialState } from './client';
import { State } from './typings';
import { Client } from '../services/typings';

const reducers = combineReducers({
  warehouse,
  cart,
  auth,
  client,
});

export const initialState: State = {
  warehouse: warehouseInitialState,
  cart: cartInitialState,
  auth: authInitialState,
  client: (clientInitialState as unknown) as Client,
};

export default reducers;
